/** FTO Pro 报告阅读后的分享与下载引导 service。 */
export interface FtoProReportOnboardingService {
    /** 初始化当前 FTO 页面作用域内的报告引导。 */
    initialize(): void;
    /** 通知 service 报告已经在真实领域边界上生成成功。 */
    notifyReportGenerated(reportId: string): void;
    /** 消费一次当前报告操作引导归因；仅在引导仍激活时返回 true。 */
    consumeActionGuide(): boolean;
    /** 仅在本地开发环境强制启动报告引导，供视觉调试入口使用。 */
    debugStart(reportId: string): void;
    /** 清理 Driver、按钮引导、监听器和定时器。 */
    destroy(): void;
}

/** FTO Pro 报告 onboarding service 的容器标识。 */
export const FtoProReportOnboardingService = Symbol('FtoProReportOnboardingService');
